import { useState, useEffect } from "react";
import ApiClient from "src/config/ApiClient";

const useOrders = () => {
  const [orders, setOrders] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const customerId = localStorage.getItem("customerId");
        if (!customerId) {
          console.error("Customer ID is missing");
          setIsLoading(false);
          return;
        }

        const response = await ApiClient.get(
          `/joinOrder/customer/${customerId}/orders`
        );
        // console.log("Track_status",response);
        setOrders(response.data.data);
      } catch (error) {
        console.error("Error fetching orders:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchOrders();
  }, []);

  return { orders, isLoading };
};

export default useOrders;
